import {runProcedure} from '../../../services/webSdk/proc';
import {EditField, InputFieldsReturn, InputOptions} from 'priority-web-sdk';

export const runDocDebitSProc = async (fromDate: string, toDate: string): Promise<string> => {
    return await runProcedure('DOC_DEBIT_S', updateDocDebitSFields(fromDate, toDate), undefined);
};

const updateDocDebitSFields =
    (fromDate: string, toDate: string) =>
    (inputFields: EditField[]): InputFieldsReturn => {
        const inputFieldsReturn = inputFields.map(field => {
            let value = field.value;

            if (inputFields.length > 1) {
                switch (field.field) {
                    case 1:
                        value = fromDate;
                        break;
                    case 2:
                        value = toDate;
                        break;
                    case 3:
                        value = value;
                        break;
                    case 4:
                        value = 'Y';
                        break;
                    case 5:
                        value = 'N';
                        break;
                    case 6:
                        value = value;
                        break;
                }
            } else {
                value = '*';
            }

            return {
                field: field.field,
                op: 0,
                value: value,
                op2: 0,
                value2: value
            };
        });
        return {EditFields: inputFieldsReturn};
    };

export const runDelayCheck2Proc = async (toDate: string): Promise<string> => {
    return await runProcedure(
        'DELAYCHECK2',
        updateDelayCheck2Fields(toDate),
        selectDelayCheck2Options
    );
};

const selectDelayCheck2Options = (options: InputOptions) => {
    return 1;
};

const selectLeasingByYearsOptions = (options: InputOptions) => {
    return 1;
};

const updateDelayCheck2Fields =
    (toDate: string) =>
    (inputFields: EditField[]): InputFieldsReturn => {
        const inputFieldsReturn = inputFields.map(field => {
            let value = field.value;
            let op = 0;
            switch (field.field) {
                case 1:
                    value = '*';
                    break;
                case 2:
                    value = toDate;
                    op = 3;
                    break;
            }

            return {
                field: field.field,
                op: op,
                value: value,
                op2: op,
                value2: value
            };
        });
        return {EditFields: inputFieldsReturn};
    };

export const runLeasingByYearsProc = async (toDate: string, years: number): Promise<string> => {
    return await runProcedure(
        'LOANS_BY_YEARS',
        updateLeasingByYearsFields(toDate, years),
        selectLeasingByYearsOptions
    );
};

const updateLeasingByYearsFields =
    (toDate: string, years: number) =>
    (inputFields: EditField[]): InputFieldsReturn => {
        const inputFieldsReturn = inputFields.map(field => {
            let value = field.value;

            if (inputFields.length === 4) {
                switch (field.field) {
                    case 1:
                        value = toDate;
                        break;
                    case 2:
                        value = years.toString();
                        break;
                    case 3:
                        value = 'Y';
                        break;
                    case 4:
                        value = 'N';
                        break;
                }
            } else {
                switch (field.field) {
                    case 1:
                        value = '*';
                        break;
                    default:
                        value = '';
                        break;
                }
            }

            return {
                field: field.field,
                op: 0,
                value: value,
                op2: 0,
                value2: value
            };
        });
        return {EditFields: inputFieldsReturn};
    };
